import React, {useState} from 'react';
import { makeStyles, Theme, useTheme} from '@material-ui/core/styles';
import {
  Button,
  TextField,
  FormControl,
  Paper,
  Box,
  Grid,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  Input,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { signUp } from "../../store/actions";
import * as paths from "./../../Routes/paths";
import { Alert } from "@material-ui/lab";
import { Link, useHistory } from 'react-router-dom';
import { loginFields, storeInfo, StoreInfo, productCategory, LoginDetails } from "./../constants";
import { analytics } from './../firebase';
import BackgroundOverlay from './../BackgroundOverlay';
import Header from './../Header';
const backgroundImage = 'https://source.unsplash.com/5E5N49RWtbA';

function getStyles(name: string, category: string[], theme: Theme) {
  return {
    fontWeight:
      category.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
  },
  image: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(7, 5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignUp = () => {
  const classes = useStyles();
  const theme = useTheme();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const history = useHistory();
const [category, setcategory] = useState<string[]>([]);
const [disabled, setDisabled] = useState(false);
const [reqError, setReqError] = useState('');
const [loginInfo, setLoginInfo] = useState<LoginDetails>({
  email: "",
  password: "",
  confirmPassword: ""
});
const [storeDetails, setStoreDetails] = useState<StoreInfo>({
  store_name: "",
  store_owner: "",
  phone_no: "",
  email:  "",
  address: "",
  state: "",
  city: "",
  password: "",
})

const dispatch = useDispatch()
  const { error } = useSelector((state: any) => {
    return state;
  });

const onChangeHandler = (e: React.ChangeEvent, changeHandler) => {
  const { name, value } = e.currentTarget as HTMLInputElement;
  changeHandler((formInfo) => ({
    ...formInfo,
    [name]: value
  }));
};
const submitForm = (event: React.FormEvent) => {
  event.preventDefault();
  setDisabled(true);
  const created_by= "storeowner";
  const submitValues = {
    store_name: storeDetails.store_name,
    store_owner: storeDetails.store_owner,
    phone_no: storeDetails.phone_no,
    address: storeDetails.address,
    city: storeDetails.city,
    state: storeDetails.state,
    password: loginInfo.password,
    product_categories: category,
    created_by
  }
  if(loginInfo.password !== loginInfo.confirmPassword){
    setReqError("Passwords did not match")
    setDisabled(false);
    return
  }
  
  if (reqError === "" && loginInfo.email.trim() && loginInfo.password.trim()) {
        try{
        dispatch(signUp(submitValues, history))
        // history.push('/a/products');
    }catch(e) {
      console.log("an error occured")
    }
    // analytics().logEvent('user registered');
  }else{
    setReqError("Form entry incorrect")
  }
};
  const handleCategoryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setcategory(event.target.value as string[]);
  };
  return (
    <div className={classes.root}>
    <Header />
    <Grid container component="main">
      <Grid item xs={false} sm={4} md={7}>
         <BackgroundOverlay backgroundClassName={classes.image}>
          {/* Increase the network loading priority of the background image. */}
        <img style={{ display: 'none' }} src={backgroundImage} alt="increase priority" />
        <Typography color="inherit" align="center" variant="h5">
          Register with betastore 
        </Typography>
        </BackgroundOverlay>
      </Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Register Your Store
          </Typography>
          <form className={classes.form} onSubmit={(e) => submitForm(e)}>
          {reqError !== '' && <Alert severity="error">{reqError}</Alert>}
            <Box>
              <Typography variant="overline">
                Login Info
              </Typography>
            </Box>
          <Grid container spacing={1}>
          {loginFields.map((field, i) => (
            <Grid item xs={12} sm={i !== 0 ? 6 : 12} key={i}>
            <TextField
              name={field.name}
              margin="normal" 
              required
              fullWidth
              id={field.name}
              label={field.label}
              value={loginInfo[field.name as keyof LoginDetails]}
              type={field.type || "text"}
              onChange={(e) => onChangeHandler(e, setLoginInfo)}
              autoComplete="on"
            /></Grid>
            ))}
            </Grid>
            <Box mt={3}>
              <Typography variant="overline">
              Store Information
            </Typography>
            </Box>
          <Grid container spacing={1}>
          {storeInfo.map((field, i) => (
            <Grid item xs={12} sm={i !== 4 ? 6 : 12} key={i}>
            <TextField
             id={field.name} 
             name={field.name} 
             label={field.label} 
             fullWidth
             autoComplete="off"
             margin="normal" 
             type="text"
             value={storeDetails[field.name as keyof StoreInfo]}
             onChange={(e) => onChangeHandler(e, setStoreDetails)}/>
             </Grid>
          ))}
          <Grid item xs={12} sm={6}>
            <Box mt={2}/>
          <FormControl variant="outlined" fullWidth>
              <InputLabel>Store Categories</InputLabel>
              <Select
                label="Store Categories"
                multiple
                input={<Input />}
                MenuProps={MenuProps}
                value={category}
                onChange={handleCategoryChange}>
                {productCategory.map((cate) => (
                  <MenuItem key={cate} value={cate} style={getStyles(cate, category, theme)}>
                    {cate}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.submit}
              disabled={disabled}
            >
              Register Store
            </Button>
            <Grid container>
              <Grid item>
                <Link to={paths.LOGIN}>
                  {"Already have an account? Sign in"}
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>
      </Grid>
    </Grid>
    </div>
  );
}

export default SignUp;